<template>
  <div
    class="flex cursor-pointer gap-x-2 overflow-x-hidden max-w-full group hover:bg-offwhite duration-150 px-4 py-2"
    :class="notificationTarget ? 'bg-offwhite rounded-lg' : ''"
    @click="activateChat"
  >
    <div class="flex w-10 h-10 items-center justify-center">
      <div
        class="bg-offwhite h-9 w-9 rounded-full flex items-center justify-center duration-150"
      >
        <div
          class="h-8 w-8 rounded-full bg-primary text-white flex justify-center items-center"
        >
          <img
            :src="parseChatIcon"
            alt="Chat icon"
            class="filter-to-white h-5 w-5"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-grow flex-col title-container justify-center">
      <span class="font-medium text-sm">{{ party.title }}</span>
      <span v-if="party.last_message" class="truncate text-sm text-grey-light">
        {{ party.last_message.author }}: {{ party.last_message.message }}
      </span>
      <span v-else class="truncate text-sm text-grey-light">
        Selles vestluses pole veel sõnumeid saadetud
      </span>
    </div>
    <div
      class="flex w-4 justify-end items-center cursor-pointer"
      @click.stop.prevent="markRead"
    >
      <span class="typcn typcn-media-record icon" v-if="notificationTarget" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatCard",
  props: {
    party: {
      type: Object,
      default: null,
    },
    notificationTarget: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    markRead() {
      this.$emit("markRead", this.party.id);
    },
    activateChat() {
      this.$emit("toggleChatTray", this.party);
    },
  },
  computed: {
    parseChatIcon() {
      if (this.party.company) {
        if (this.party.project) return "/icons/briefcase.svg";
        if (this.party.client) return `/pricing/cli.svg`;
        if (this.party.task) return "/pricing/pm.svg";
        if (this.party.worker) return `/bc21/worker.svg`;
        return `/bc21/kliendid.svg`;
      }
      return "/pricing/em.svg";
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  max-width: calc(100% - 5rem);
}
</style>
